export default "__VITE_ASSET__2b64470e__"